import React, { useEffect, useRef, useState } from 'react';

export default function BackgroundAudioPlayer({ src, loop = true, volume = 0.3 }) {
  const audioRef = useRef(null);
  const [muted, setMuted] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    audio.loop = loop;
    audio.volume = volume;
    audio.autoplay = true;

    // Try to play the audio
    const tryPlay = async () => {
      try {
        await audio.play();
        setIsPlaying(true);
      } catch (err) {
        // Autoplay blocked - audio will start when user interacts with the page
        console.log('Autoplay blocked, audio will start on user interaction');
        setIsPlaying(false);
      }
    };

    tryPlay();
  }, [src, loop, volume]);

  const togglePlay = async () => {
    const audio = audioRef.current;
    if (!audio) return;

    if (isPlaying) {
      audio.pause();
      setIsPlaying(false);
    } else {
      try {
        await audio.play();
        setIsPlaying(true);
      } catch (err) {
        console.log('Could not play audio');
      }
    }
  };

  const toggleMute = () => {
    const audio = audioRef.current;
    if (!audio) return;
    audio.muted = !audio.muted;
    setMuted(audio.muted);
  };

  return (
    <>
      <audio ref={audioRef} src={src} preload="auto" />
      
      {/* Play and mute buttons */}
      <div className=" right-4 fixed right-4 bottom-4 z-500" style={{ position: "fixed",bottom:"20px",right:"150px" }}>
        <div className="flex items-center space-x-2">
          <button
            onClick={togglePlay}
            aria-label={isPlaying ? 'Pause background audio' : 'Play background audio'}
            className="w-12 h-12 rounded-full bg-white/90 dark:bg-black/70 backdrop-blur-sm shadow-lg flex items-center justify-center transition-transform hover:scale-105"
          >
            {isPlaying ? '⏸️' : '▶️'}
          </button>
          <button
            onClick={toggleMute}
            aria-label={muted ? 'Unmute background audio' : 'Mute background audio'}
            className="w-12 h-12 rounded-full bg-white/90 dark:bg-black/70 backdrop-blur-sm shadow-lg flex items-center justify-center transition-transform hover:scale-105"
          >
            {muted ? '🔇' : '🔊'}
          </button>
        </div>
      </div>
    </>
  );
}
